import React, { useState, useEffect } from 'react';
import { Grid, Typography, CircularProgress, Breadcrumbs } from '@mui/material';
import { Link } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import PerguntaService from 'services/perguntasService'; 
import PerguntaTable from './PerguntaTabela';
import PerguntaActions from './PerguntaAcao';
import PerguntaModals from './PerguntaModal';

const TabelaPerguntas = () => {
  const [perguntas, setPerguntas] = useState([]);
  const [filtroTabela, setFiltro] = useState('');
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [isSubPergunta, setIsSubPergunta] = useState(false);
  const [modalTipo, setModalTipo] = useState('novo');
  const [perguntaAtual, setPerguntaAtual] = useState(null);
  const [visualizarModalIsOpen, setVisualizarModalIsOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    atualizarPerguntas();
  }, []);

  const atualizarPerguntas = async () => {
    setLoading(true);
    try {
      const data = await PerguntaService.getPerguntas();
      setPerguntas(data || []); 
    } catch (error) {
      console.error('Erro ao atualizar as perguntas:', error);
      enqueueSnackbar('Erro ao atualizar as perguntas.', { variant: 'error' });
    } finally {
      setLoading(false);
    }
  };

  const handleFiltroChange = (novoFiltro) => {
    setFiltro(novoFiltro);
  };

  const excluirPergunta = async (id) => {
    const confirmar = window.confirm('Tem certeza de que deseja excluir esta pergunta?');
    if (confirmar) {
      try {
        await PerguntaService.excluirPergunta(id); // Chama o método de exclusão do serviço
        await atualizarPerguntas(); // Recarrega as perguntas após a exclusão
        enqueueSnackbar('Questão excluída com sucesso', { variant: 'success' });
      } catch (error) {
        console.error('Erro ao excluir a pergunta:', error);
        enqueueSnackbar('Erro ao excluir a questão', { variant: 'error' });
      }
    }
  };

  // Função para abrir o modal
  const openModal = (tipo, pergunta = null, isSubPergunta = false) => {
    setModalTipo(tipo);
    setPerguntaAtual(pergunta);
    setIsSubPergunta(isSubPergunta); // Atualiza o estado se for subpergunta
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
    setPerguntaAtual(null);
    setIsSubPergunta(false); // Reseta o estado de subpergunta ao fechar o modal
  };

  const openVisualizarModal = () => {
    setVisualizarModalIsOpen(true);
  };

  const closeVisualizarModal = () => {
    setVisualizarModalIsOpen(false);
  };

  const perguntasPrincipais = perguntas.filter(pergunta => !pergunta.pai_id );
  const perguntasFiltradas = perguntasPrincipais.filter(pergunta => pergunta.texto.toLowerCase().includes(filtroTabela.toLowerCase()));

  return (
    <Grid container direction="column" style={{ padding: '0 20px', minHeight:'90vh' }}>
      <Grid container justifyContent="space-between" alignItems="center" style={{ marginBottom: '20px' }}>
        <Breadcrumbs aria-label="breadcrumb">
          <Link color="inherit" to="/admin/principal">Home</Link>
          <Typography color="textPrimary">Questionário</Typography>
        </Breadcrumbs>
      </Grid>

      <PerguntaActions
        handleFiltroChange={handleFiltroChange}
        openVisualizarModal={openVisualizarModal}
        openModal={openModal}
      />

      {loading ? (
        <Grid style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
          <CircularProgress />
        </Grid>
      ) : (
        <PerguntaTable
          perguntasFiltradas={perguntasFiltradas}
          openModal={openModal}
          excluirPergunta={excluirPergunta}
          filtro={filtroTabela}
        />
      )}

      <PerguntaModals
        modalIsOpen={modalIsOpen}
        closeModal={closeModal}
        modalTipo={modalTipo}
        perguntaAtual={perguntaAtual}
        atualizarPerguntas={atualizarPerguntas}
        visualizarModalIsOpen={visualizarModalIsOpen}
        closeVisualizarModal={closeVisualizarModal}
        isSubPergunta={isSubPergunta}  
      />
    </Grid>
  );
};

export default TabelaPerguntas;
